import React, {Fragment, useState} from 'react';
import {Button, Col, Input, Modal, Row, Select} from 'antd';
import {GUTTER_SM, MODAL_WIDTH_MD} from '../../../../styles/constants';
import _ from 'lodash';
import {DataLanguageConsumer} from "../../../../contexts/DataLanguage";
import ItemList from "../../../item-list";
import EnhancedModal from "../../../enhanced-modal";
import Selector from "../../../selector";
import {getLocalizedStr} from "../../../../middlewares/i18n/utils";
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import InfiniteScrollDataTable from "../../../infinite-scroll-data-table";

const mapStateToProps = state => ({
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages
});

const FilterFormBlockCondition = ({
                                    t,
                                    appLanguage,
                                    dataLanguages,
                                    form,
                                    blockIndex,
                                    index,
                                    values,
                                    valuesCount,
                                    fetchValues,
                                    resetValues,
                                    isNumeric,
                                    hasCodelist,
                                    codes,
                                    colName,
                                    onDelete,
                                    disabled
                                  }) => {

    const [isValuesModalVisible, setIsValuesModalVisible] = useState(false);
    return (
      <Row type="flex" gutter={GUTTER_SM} justify="space-between">
        <Col span={5}>
          {form.getFieldDecorator(`filter[${blockIndex}].conditions[${index}].comparisonOperator`)(
            <Select style={{width: '100%'}} size="small" disabled={disabled}>
              {
                _.compact([
                  '=',
                  '<>',
                  !isNumeric ? 'like' : null,
                  '<',
                  '>',
                  '<=',
                  '>='
                ])
                  .map(op => <Select.Option key={op} value={op}>{op}</Select.Option>)
              }
            </Select>
          )}
        </Col>
        <Col span={16}>
          {form.getFieldDecorator(`filter[${blockIndex}].conditions[${index}].value`)(
            values !== undefined && (
              form.getFieldValue(`filter[${blockIndex}].conditions[${index}].comparisonOperator`) &&
              form.getFieldValue(`filter[${blockIndex}].conditions[${index}].comparisonOperator`) !== 'like'
            )
              ? (
                <DataLanguageConsumer>
                  {dataLanguage =>
                    <Fragment>
                      {form.getFieldDecorator(`filter[${blockIndex}].conditions[${index}].value`)(
                        <Selector
                          style={{top: 0}}
                          size="small"
                          selectTitle={t('components.whereConditionsForm.block.condition.selectValueButton.title')}
                          resetTitle={t('components.whereConditionsForm.block.condition.resetValueButton.title')}
                          onSelect={() => setIsValuesModalVisible(true)}
                          onReset={() => {
                            const filter = [];
                            const conditions = []
                            conditions[index] = {
                              value: null
                            };
                            filter[blockIndex] = {
                              conditions
                            };
                            form.setFieldsValue({filter});
                          }}
                          disabled={disabled}
                          render={value =>
                            (value !== null && hasCodelist)
                              ? `${value} (${getLocalizedStr(codes.find(({id}) => id === value).name, dataLanguage || appLanguage, dataLanguages)})`
                              : value
                          }
                        />
                      )}
                      <EnhancedModal
                        visible={isValuesModalVisible}
                        width={MODAL_WIDTH_MD}
                        title={t('components.whereConditionsForm.block.condition.selectValueModal.title')}
                        onCancel={() => {
                          resetValues();
                          setIsValuesModalVisible(false);
                        }}
                        footer={
                          <Button onClick={() => {
                            resetValues();
                            setIsValuesModalVisible(false);
                          }}>
                            {t('commons.buttons.close.title')}
                          </Button>
                        }
                        withDataLanguageSelector={!isNumeric}
                      >
                        <DataLanguageConsumer>
                          {dataLanguage => {
                            return (
                              hasCodelist
                                ? (
                                  <ItemList
                                    noFilter
                                    noSort
                                    data={values || null}
                                    rowCount={valuesCount}
                                    isPaginated
                                    onChange={
                                      ({
                                         pageNum,
                                         pageSize,
                                         searchText
                                       }) => {

                                        const filteredCodes =
                                          searchText
                                            ? codes.filter(({id, name}) =>
                                              id.toLowerCase().includes(searchText.toLowerCase()) ||
                                              getLocalizedStr(name, dataLanguage || appLanguage, dataLanguages)
                                                .toLowerCase().includes(searchText.toLowerCase())
                                            )
                                            : null;

                                        const call = () => {

                                          fetchValues({
                                            pageNum,
                                            pageSize,
                                            filterObj:
                                              searchText
                                                ? (
                                                  [{
                                                    column: colName,
                                                    conditions:
                                                      filteredCodes.length > 0
                                                        ?
                                                        filteredCodes
                                                          .map(({id}) => ({
                                                            comparisonOperator: "=",
                                                            value: id
                                                          }))
                                                        : [
                                                          {
                                                            comparisonOperator: "=",
                                                            value: "DUMMY_VALUE_FOR_NO_RESULTS"
                                                          }
                                                        ],
                                                    isOr: false
                                                  }]
                                                )
                                                : null
                                          });
                                        }

                                        if (searchText && filteredCodes.length > 1000) {
                                          Modal.error({
                                            title: t('components.whereConditionsForm.block.condition.selectValueModal.tooManyCodesAlert.title'),
                                            content: t('components.whereConditionsForm.block.condition.selectValueModal.tooManyCodesAlert.content'),
                                          });
                                        } else {
                                          call();
                                        }

                                      }}
                                    onRowClick={row => {
                                      const filter = [];
                                      const conditions = []
                                      conditions[index] = {
                                        value: row.id,
                                      };
                                      filter[blockIndex] = {
                                        conditions
                                      };
                                      form.setFieldsValue({filter});
                                      resetValues();
                                      setIsValuesModalVisible(false);
                                    }}
                                  />
                                )
                                : (
                                  <InfiniteScrollDataTable
                                    noFilter
                                    noSort
                                    data={values || null}
                                    rowTotal={valuesCount}
                                    cols={[colName]}
                                    onChange={
                                      ({pageNum, pageSize, searchText}) =>
                                        fetchValues({
                                          pageNum,
                                          pageSize,
                                          searchText
                                        })
                                    }
                                    onRowClick={row => {
                                      const filter = [];
                                      const conditions = []
                                      conditions[index] = {
                                        value: row[colName]
                                      };
                                      filter[blockIndex] = {
                                        conditions
                                      };
                                      form.setFieldsValue({filter});
                                      resetValues();
                                      setIsValuesModalVisible(false);
                                    }}
                                  />
                                )
                            );
                          }}
                        </DataLanguageConsumer>
                      </EnhancedModal>
                    </Fragment>
                  }
                </DataLanguageConsumer>
              )
              : (
                <Input
                  disabled={
                    form.getFieldValue(`filter[${blockIndex}].conditions[${index}].comparisonOperator`) === null ||
                    disabled
                  }
                  style={{width: '100%'}}
                  size="small"
                />
              )
          )}
        </Col>
        <Col span={3}>
          <Button onClick={onDelete} icon="delete" size="small" style={{width: '100%'}}
                  disabled={disabled}/>
        </Col>
      </Row>
    );
  }
;

export default compose(
  translate(),
  connect(mapStateToProps)
)(FilterFormBlockCondition);

